export default "__VITE_ASSET__c35d057a__"